export const MISSION_PLANNER_DISTANCE_KEYS = {
  main: 'mp-distance',
};

export const missionPlannerDistanceQueryKeys = {
  getDistance: (...args: unknown[]) => [MISSION_PLANNER_DISTANCE_KEYS.main, ...args],
};
